import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router';
import { useAuthStore } from '@/stores/auth';

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'home',
    component: () => import('@/views/HomeView.vue'),
    meta: { title: 'watch.silxnt.dev', fullBleed: true },
  },
  {
    path: '/search',
    name: 'search',
    component: () => import('@/views/SearchView.vue'),
    meta: { title: 'Suchen — watch.silxnt.dev', requiresAuth: true },
  },
  {
    path: '/list',
    name: 'list',
    component: () => import('@/views/ListView.vue'),
    meta: { title: 'Meine Liste — watch.silxnt.dev', requiresAuth: true },
  },
  {
    path: '/anime/:id',
    name: 'anime',
    component: () => import('@/views/AnimeView.vue'),
    props: (route) => ({ id: Number(route.params.id) }),
    meta: { title: 'Anime — watch.silxnt.dev' },
  },
  {
    path: '/u/:discord_id',
    name: 'profile',
    component: () => import('@/views/ProfileView.vue'),
    props: true,
    meta: { title: 'Profil — watch.silxnt.dev' },
  },
  {
    path: '/share/:id',
    name: 'share',
    component: () => import('@/views/ShareView.vue'),
    props: true,
    meta: { title: 'Geteilt — watch.silxnt.dev' },
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'not-found',
    component: () => import('@/views/NotFoundView.vue'),
  },
];

export const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior() {
    return { top: 0 };
  },
});

router.beforeEach(async (to) => {
  const auth = useAuthStore();
  if (auth.status === 'idle') await auth.fetchMe();

  if (to.meta.requiresAuth && !auth.isAuthenticated) {
    return { name: 'home', query: { next: to.fullPath } };
  }
  return true;
});

router.afterEach((to) => {
  const title = (to.meta.title as string | undefined) ?? 'watch.silxnt.dev';
  document.title = title;
});
